import MagazineLayout from "@/components/MagazineLayout";
import { Reveal } from "@/components/Reveal";
import Seo from "@/components/Seo";

export default function PartnerOffers() {
  return (
    <MagazineLayout>
      <Seo title="Partners — Coming Soon | S/ME" description="Partner offers from brands that love independent business — coming soon to S/ME." />
      <div className="max-w-3xl mx-auto px-4 sm:px-8 py-28 sm:py-40 text-center" data-testid="partners-coming-soon">
        <Reveal>
          <p className="overline text-gloss-gold mb-6">Partners</p>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl mb-6">Coming soon.</h1>
          <p className="font-sans text-base text-ink/60 max-w-xl mx-auto">
            Corporate partner offers for S/ME members are on their way. In the meantime, the Noticeboard is where our members showcase what's happening in their world.
          </p>
        </Reveal>
      </div>
    </MagazineLayout>
  );
}
